/** menu 组件类型，包括 MenuItem，SubMenu，MenuItemGroup */
export enum MenuBlockType {
  MenuItem = 'MenuItem',
  SubMenu = 'SubMenu',
  MenuItemGroup = 'MenuItemGroup',
  MenuGroup = 'MenuGroup',
}
